import { csv } from "d3";
import { useState, useEffect } from "react";
import countryCsv from "./country_list.csv";

const useCountryList = () => {
  const [countries, setCountries] = useState();
  useEffect(() => {
    const row = (d) => {
      d.month_change = +d.month_change;
      d.year_change = +d.year_change;
      return d;
    };
    csv(countryCsv, row).then((countryList) => {
      let countriesObj = {};
      countryList.map((d) => {
        countriesObj[d.country] = {
          month_change: d.month_change,
          year_change: d.year_change
        };
      })
      setCountries(countriesObj)
    });
  }, []);
  return countries
};

export default useCountryList;
